// Different style than "CrossIcon"

const CloseIcon = ({ className = '' }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={`stroke-[#575372] ${className}`}
  >
    <path
      d='M10.6666 5.33148L5.33325 10.6648'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
    <path
      d='M10.6666 10.6648L5.33325 5.33148'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
  </svg>
)

export default CloseIcon
